import React, {useState} from 'react';
import style from './style';
import EADataGrid from "components/common/datatable/EADataGrid";
import {thirdPartyListColumns} from "./ThirdPartyListColumns";
import {useHistory} from "react-router-dom";
import i18next from "i18next";

const ThirdPartyList = ({thirdPartyList, editTp, addedTpList, existingAssosciated, startPoint}) => {
  const {classes} = style();
  const history = useHistory();

  const [, setFilterRowCount] = useState(0);

  return <>
    <div className={classes.titleWrapper}>
      <div className={classes.title}>
        {i18next.t("context.addTiers.searchRes")}
      </div>
      <div className={classes.results}>
        {thirdPartyList.length+' '+i18next.t("context.addTiers.res")}
      </div>
    </div>
    <EADataGrid
      loading={false}
      inputRows={thirdPartyList}
      getRowId={(row) => row.thirdpartyId}
      columns={
        thirdPartyListColumns(history, editTp, addedTpList, existingAssosciated, startPoint)
      }
      className={classes.root}
      customSx={{
        "& .MuiDataGrid-columnHeader:nth-child(2)": {color: "#7E7E8F"},
      }}
      onStateChange={(e) => {
        setFilterRowCount(e.pagination.rowCount);
      }}
      paginationMode={'client'}
      hasFilters={false}
      noFilter={true}
      pageSize={10}
      disableToolBar={true}
      density={'standard'}
    />
  </>
}

export default ThirdPartyList